import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const DeleteConfirmationModal = ({
  item,
  itemType,
  show,
  onClose,
  onDelete,
}) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  const getItemMessage = () => {
    if (itemType === "lesson") {
      return t("delete_lesson_message");
    }
    if (itemType === "section") {
      return t("delete_section_message");
    }
    return "";
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("delete_confirmation_title", {
            itemType: t(itemType),
            itemTitle: item.title,
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{getItemMessage()}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel_button")}
        </Button>
        <Button variant="danger" onClick={() => onDelete(item.id)}>
          {t("delete_button")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
